import sendBill from "./en/send_bill"
import vote from "./en/vote"

export default {
  sendBill: sendBill,
  vote: vote
}
